<template>
  <button
    @click="logout"
    class="btn btn-text"
  >
    <app-icon
      name="log-out"
      class="text-gray-500"
    />
    Log out
  </button>
</template>

<script setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { clearStickyFiltersStorage } from '@/composables/useFilterUrlSync.js';

const { logout: logoutAuth0 } = useAuth0();
const logout = () => {
  clearStickyFiltersStorage();
  logoutAuth0({ logoutParams: { returnTo: window.location.origin + '/auth/login' } });
};
</script>
